import { mountMorePage } from '../../../../../shared/scripts/more/mountMorePage.ts';
import { UIPopupRulebook } from '../../../../../shared/scripts/ui_popup/UIPopupRulebook.ts';
import { RulebookPage } from '../../../../../../shared/enums/RulebookEnums.ts';
import { FAQ_URL } from '@colonist/consts';
export class UIDMoreSceneController {
    hide() {
        this.moreSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.moreSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.activateMore();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.moreSceneContainerDiv = document.getElementById('scene_discord_more_container');
        mountMorePage('discord-more-page-container', ()=>new UIPopupRulebook(RulebookPage.Classic4P).show(), {
            faqExternalUrl: FAQ_URL
        });
    }
}
